import { START_GET_SEMINARTYPES } from '../types';
    
export const getSeminartypes = payload => ({
    type: START_GET_SEMINARTYPES,
    payload
})